import type { ServiceForSelectedServiceType } from '@common/interfaces/processStartWizard';
import { ServiceCode } from '@common/enums';
import { never } from '@common/utils/never';
import type { IServiceDataItem } from './getServiceData';

export type ophthalmologyServiceCodeType = ServiceCode.TFO | ServiceCode.TOO | ServiceCode.OrthO | ServiceCode.OrthOFol;

export function getServiceDataForEpisodeOphthalmology(
    service: ServiceForSelectedServiceType,
    serviceCode: ophthalmologyServiceCodeType
): Partial<IServiceDataItem> {
    switch (serviceCode) {
        case ServiceCode.TFO:
            return {
                costs: 'eigen risicovrij',
                order: 1,
                steps: [
                    'Binnen 3 werkdagen kan de patiënt terecht bij een optometrist in de buurt',
                    'Bij afwijking is digitaal consult van de oogarts mogelijk',
                    ' Je ontvangt de uitslag via Edifact (in je HIS)',
                ],
                subTitle: (
                    <>
                        Netvliesscreening bij <strong>diabetespatiënten</strong>
                    </>
                ),
                title: 'Fundusscreening',
                waitingTime: '1 week',
            };

        case ServiceCode.TOO:
            return {
                costs: 'meestal eigen risicovrij',
                costsToolTipText:
                    'M.u.v. CZ, Zorg en Zekerheid en DSW. Hierbij wordt het eigen risico belast tot 150 euro.',
                order: 2,
                steps: [
                    'Binnen 3 werkdagen kan de patiënt terecht bij een optometrist in de buurt',
                    'De oogarts kijkt digitaal mee',
                    'Je ontvangt de uitslag via Edifact (in je HIS)',
                ],
                subTitle: (
                    <>
                        Voor het beoordelen van <strong>niet-acute oogklachten</strong>
                    </>
                ),
                title: 'Optometrisch onderzoek',
                waitingTime: '1 week',
            };

        case ServiceCode.OrthO:
        case ServiceCode.OrthOFol:
            return {
                costs: 'meestal eigen risicovrij',
                costsToolTipText: '<18 of Menzis onbelast, rest belast tot max. 135 euro',
                order: 3,
                steps: [
                    'Binnen 3 werkdagen kan de patiënt terecht bij een orthoptist in de buurt',
                    'De oogarts kijkt digitaal mee',
                    'Je ontvangt de uitslag via Edifact (in je HIS)',
                ],
                subTitle: (
                    <>
                        Voor kinderen en volwassenen met <strong>leesproblemen, scheel- en dubbelzien</strong>
                    </>
                ),
                title: 'Orthoptisch onderzoek',
                waitingTime: '1 week',
            };

        default:
            never(serviceCode);
    }
}
